import styled from "styled-components";
import { Grid, Typography, Input } from "@mui/material";

export const SInputContainer = styled(Grid)`
  && {
    display: flex;
    margin: 0px 10px;
  }
`;

export const SLabel = styled(Typography)`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    width: fit-content;
    height: 36px;
    font-size: 14px;
    line-height: 24px;
    margin-right: 10px;
    color: ${({ theme }) => theme.colors.periodButtonDark};
  }
`;

export const SInputField = styled(Input)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.textGray};
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 10px 16px;
    width: 70px;
    height: 36px;
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.bgGray || "gray"};

    .MuiInput-input {
      padding: 0;
    }

    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0 30px
        ${({ theme }) => theme.colors.bgGray || "gray"} inset;
    }
  }
`;
